import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Image from "next/legacy/image";
import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";
import { getAssets } from "@unisearch/helpers";
import { useInView } from "react-intersection-observer";
import styles from "./styles/hero.module.scss";

export const AboutusHero = ({ video }) => {
  const [isOpen, setOpen] = useState(false);
  const { ref, inView, entry } = useInView();
  useEffect(() => {
    if (inView) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [inView]);

  return (
    <section className={styles.section_aboutus_hero}>
      <div className="container">
        <Grid
          container
          spacing={{ xs: 2, sm: 3, md: 5, xl: 10 }}
          alignItems="center"
        >
          <Grid item xs={12} sm={12} md={6}>
            <h4>Learn</h4>
            <h1>
              <span className="mark">About Us</span>
            </h1>
            <p>
              Our goal at UniSearch is simple - to make every stage of studying
              abroad accessible through a single platform. We understand that
              international student recruitment is an ever-changing landscape.
              Universities have their work cut out finding and engaging the most
              promising candidates for their programs while unique student
              markets, with distinct engagement factors, continue to emerge.
              Students, in turn, face the daunting task of trying to find
              information from hundreds of different sources to choose and apply
              to the right university. They often make big decisions based on
              incomplete data.
            </p>
            <p>
              This is why we built UniSearch - a single stop through which
              students can research, find, connect with, and apply to their
              ideal university. We bring together innovative and intelligent
              systems and expertise in emerging student markets to create a
              complete platform that simplifies study abroad, with a
              personalised approach for each student and university partner.
            </p>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <div className={styles.right}>
              <div className={styles.video_wrapper}>
                <img
                  src={getAssets("assets/images/exam/ornaments.png")}
                  alt="ornaments"
                  className={styles.ornaments}
                />
                <img
                  src={getAssets("assets/images/exam/circle.png")}
                  alt="circle"
                  className={styles.circle}
                />
                <div className={styles.video_image_wrpper}>
                  <Image
                    layout="responsive"
                    width={577}
                    height={372}
                    blurDataURL={getAssets(
                      "assets/images/study/country_placeholder.webp"
                    )}
                    placeholder="blur"
                    src={getAssets("/assets/images/exam/library.webp")}
                    alt="library"
                  />
                </div>

                {isOpen && (
                  <div className={styles.iframe_video_wrapper}>
                    <iframe
                      src="https://www.youtube.com/embed/xkLBRlq-jpY?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1&loop=1"
                      width="100%"
                      height="100%"
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                  </div>
                )}
                <div className={styles.ref} ref={ref}></div>
                <PlayButtonWithRipple onClick={() => setOpen(true)} />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default AboutusHero;
